import type {
	AiFeatureRequestEnvelopeNudgeThrottlingStateRequest,
	AIFeatureResponseEnvelopeNudgeThrottlingStateResponse,
} from '@atlassian/convo-ai-api';

const CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';

const ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_LIMITER';

type FetchNudgeThrottlingStateProps = {
	triggerId: string;
};

export const fetchNudgeThrottlingState = async ({ triggerId }: FetchNudgeThrottlingStateProps) => {
	const request: AiFeatureRequestEnvelopeNudgeThrottlingStateRequest = {
		ai_feature_input: {
			triggers: [
				{
					trigger_id: triggerId,
					trigger_type: ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE,
				},
			],
		},
	};

	const response = await fetch(CONVO_AI_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'X-Product': 'confluence',
			'X-Experience-Id': 'ai-mate',
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Error fetching nudge throttling state, status code: ${response.status}`);
	}

	const { ai_feature_output }: AIFeatureResponseEnvelopeNudgeThrottlingStateResponse =
		(await response.json()) ?? {};

	if (!ai_feature_output) {
		throw new Error('No nudge throttling state returned from API');
	}

	return ai_feature_output;
};
